import { render, staticRenderFns } from "./UserSubscriptionView.vue?vue&type=template&id=2d434f58&lang=true"
import script from "./UserSubscriptionView.vue?vue&type=script&lang=js"
export * from "./UserSubscriptionView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports